import * as React from 'react';

import { Input as InputPrimitive } from '@base-ui/react/input';

import { cn } from '@crm/shared/lib/styles/utils';

import { inputVariants, type InputVariants } from './input.variants';

type InputProps = React.ComponentProps<'input'> & InputVariants;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, variant = 'default', ...props }, ref) => (
        <InputPrimitive
            ref={ref}
            type={type}
            data-slot="input"
            className={cn(inputVariants({ variant, className }))}
            {...props}
        />
    ),
);

Input.displayName = 'Input';

export { Input };
export type { InputProps };
